module.exports = __webpack_public_path__ + "media/images/zoomify_scroll-bba81609b301c945af6d92ad058a7b52.png";